<template>
  <router-view></router-view>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "App",
  created() {
    this.initializeApp();
  },
  methods: {
    ...mapActions("auth", ["initializeApp"]),
  }
};
</script>

<style>
#building {
  scroll-margin-top: 120px;
}
#microcertificacao1 {
  scroll-margin-top: 140px;
}
#microcertificacao2 {
  scroll-margin-top: 140px;
}
#microcertificacao3 {
  scroll-margin-top: 120px;
}
#microcertificacao4 {
  scroll-margin-top: 110px;
}
#faq {
  scroll-margin-top: 120px;
}
</style>